import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';

import { status } from 'constants/general';
import { fetchUpdateProfileInfo } from 'modules/profiles/actions';
import { fetchCompanyProfilesList } from 'modules/common/actions';
import UpdateProfileComponent from 'modules/profiles/components/UpdateProfileComponent';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const UpdateProfileContainer = ({ profileDetailsApiCall }) => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const { profileDetails } = useSelector(state => ({
    profileDetails: state.profiles.profileDetails,
  }));

  const dispatch = useDispatch();
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [formFieldsValues, setFormFieldsValues] = useState({
    name: profileDetails?.details?.name || '',
    description: profileDetails?.details?.description || '',
    longDescription: profileDetails?.details?.longDescription || '',
    email: profileDetails?.details?.email || '',
    url: profileDetails?.details?.websiteUrl || '',
    imageData: null,
  });
  const [shouldShowErrorMessage, setShouldShowErrorMessage] = useState(false);
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  useEffect(() => {
    if (profileDetails.status === status.SUCCESS) {
      setFormFieldsValues(prevValue => {
        const fieldsObj = { ...prevValue };
        fieldsObj.name = profileDetails.details.name || '';
        fieldsObj.description = profileDetails.details.description || '';
        fieldsObj.longDescription = profileDetails.details.longDescription || '';
        fieldsObj.email = profileDetails.details.email || '';
        fieldsObj.url = profileDetails.details.websiteUrl || '';

        return fieldsObj;
      });
    }
  }, [profileDetails]);
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  const updateProfileSuccessCallback = () => {
    const body = {
      data: {
        page: 1,
        pageSize: 12,
      },
    };
    dispatch(fetchCompanyProfilesList(body));

    profileDetailsApiCall();

    setShouldShowErrorMessage(false);
    setFormFieldsValues(prevValue => {
      const fieldsObj = { ...prevValue };
      fieldsObj.imageData = null;

      return fieldsObj;
    });
  };

  const updateProfileFailCallback = () => {
    setShouldShowErrorMessage(true);
  };
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleTextInputFieldChange = (fieldName, fieldEvent) => {
    const { value } = fieldEvent.target;

    setFormFieldsValues(prevValue => {
      const fieldsObj = { ...prevValue };
      fieldsObj[fieldName] = value;

      return fieldsObj;
    });
  };

  const handleUploadFileChange = fileData => {
    setFormFieldsValues(prevValue => {
      const fieldsObj = { ...prevValue };
      fieldsObj.imageData = fileData;

      return fieldsObj;
    });
  };

  const handleUpdateProfileBtnClick = () => {
    const { name, description, longDescription, email, url, imageData } = formFieldsValues;

    if (name || email || description || imageData) {
      const body = {
        data: {
          name,
          description,
          longDescription,
          email,
          url,
          imageData,
        },
        callbackActionSuccess: updateProfileSuccessCallback,
        callbackActionFail: updateProfileFailCallback,
      };

      dispatch(fetchUpdateProfileInfo(body));
    }
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <UpdateProfileComponent
      formFieldsValues={formFieldsValues}
      shouldShowErrorMessage={shouldShowErrorMessage}
      handleTextInputFieldChange={handleTextInputFieldChange}
      handleUploadFileChange={handleUploadFileChange}
      handleUpdateProfileBtnClick={handleUpdateProfileBtnClick}
    />
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

UpdateProfileContainer.propTypes = {
  profileDetailsApiCall: PropTypes.func.isRequired,
};

UpdateProfileContainer.defaultProps = {};

export default UpdateProfileContainer;
